import React from 'react';
import cn from 'classnames';
import InputFeedback from './InputFeedback';

const metricMapping = {
  time: 'мин.',
  reps: 'повт.',
  weight: 'кг.',
};

/**
 * Form text input.
 */
const TextInput = ({
  name,
  value,
  onChange,
  label,
  placeholder,
  error,
  success,
  type = 'text',
  disabled = null,
  metric = null,
}) => {
  const metricLabel = metric in metricMapping ? metricMapping[metric] : '';
  return (
    <label
      className={cn('u-flex u-flex-column u-full-width u-margin-bottom-tiny', {
        'u-no-pointer-events': disabled,
      })}
    >
      {label && <span className="u-margin-bottom-small">{label}</span>}
      <div className="u-position-relative">
        <input
          className={cn('c-input', {
            'u-padding-right-large': !!metric,
          })}
          placeholder={placeholder}
          name={name}
          type={type}
          value={value}
          onChange={onChange}
          disabled={disabled}
        />
        {metric && <span className="c-input__metric">{metricLabel}</span>}
      </div>
      {success ? (
        <InputFeedback type="success" message={success} />
      ) : (
        <InputFeedback message={error} />
      )}
    </label>
  );
};

export default TextInput;
